import { render } from "./DynamicComponent.vue?vue&type=template&id=94c08eb0&ts=true"
import script from "./DynamicComponent.vue?vue&type=script&lang=ts"
export * from "./DynamicComponent.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__